import React from 'react'
import '../Styles/topCards.css'

const TopBarCards = ({heading,title,content}) => {
  return (
    <div className='top-main'>
        <h1 className='top-heading'>{heading}</h1>
        <h3 className='top-title'>{title}</h3>
        <p className='top-content'>{content}</p>
    </div>
  )
}

export default TopBarCards